<template>
  <div>
    <div class="row">
      <div :class="sensorActive ? 'col-12 col-lg-4' : 'col-12'">
        <h1
          class='text-primary font-weight-bolder'
        >
          Поиск номеров
        </h1>
        <div class="row" v-if="!sensorActive">
          <div class="col-12 col-md-6 mb-2">
            В качестве любая цифра остаьте ячейку пустым.<br>
            Например: 9_7__2000, 91888______, 71____888, 17_0____5, 75555___5.
          </div>
          <div class="col-12 col-md-6 mb-2">
            <span class="btn btn-primary font-medium-5 p-50 mr-1" @click="setPrefixNUmber('98')">98</span>
            <span class="btn btn-primary font-medium-5 p-50 mr-1" @click="setPrefixNUmber('94')">94</span>
            <span class="btn btn-primary font-medium-5 p-50 mr-1" @click="setPrefixNUmber('918')">918</span>
            <span class="btn btn-primary font-medium-5 p-50 mr-1" @click="setPrefixNUmber('71')">71</span>
            <span class="btn btn-primary font-medium-5 p-50 mr-1" @click="setPrefixNUmber('17')">17</span>
            <span class="btn btn-primary font-medium-5 p-50" @click="setPrefixNUmber('75')">75</span>
          </div>
        </div>
      </div>
      <div v-if="sensorActive" class="col-12 mb-2 col-lg-4">
        <span class="btn btn-primary font-medium-5 p-50 mr-1" @click="setPrefixNUmber('98')">98</span>
        <span class="btn btn-primary font-medium-5 p-50 mr-1" @click="setPrefixNUmber('94')">94</span>
        <span class="btn btn-primary font-medium-5 p-50 mr-1" @click="setPrefixNUmber('918')">918</span>
        <span class="btn btn-primary font-medium-5 p-50 mr-1" @click="setPrefixNUmber('71')">71</span>
        <span class="btn btn-primary font-medium-5 p-50 mr-1" @click="setPrefixNUmber('17')">17</span>
        <span class="btn btn-primary font-medium-5 p-50" @click="setPrefixNUmber('75')">75</span>
      </div>
      <div class="col-12 col-lg-4">

      </div>
    </div>

    <SearchForm ref='searchForm' @input-focus="show" @keyboard-hide="hide" />

    <vue-touch-keyboard :options="options" v-if="visible" :layout="layout" :cancel="hide" :accept="accept"
                        :input="input"/>
  </div>
</template>

<script>
import SearchForm from '@/views/frontend/components/numbers/components/SearchForm.vue'
// import SimpleKeyboard from '@/@core/components/app-keyboard/SimpleKeyboard.vue'
import '@/@core/components/app-keyboard/vue-touch-keyboard/dist/vue-touch-keyboard.css' // load default style

export default {
  name: 'Contents',
  data: () => ({
    // input: '',
    inputs: {
      firstDigit: '',
      secondDigit: '',
      thirdDigit: '',
      fourthDigit: '',
      fifthDigit: '',
      sixthDigit: '',
      seventhDigit: '',
      eighthDigit: '',
      ninethDigit: '',
    },
    activeInput: 'firstDigit',
    visible: false,
    layout: 'normal',
    input: null,
    options: {
      useKbEvents: false,
    },
    sensorActive: false,
  }),
  components: {
    SearchForm,
    // SimpleKeyboard,
  },
  methods: {
    inputClick(inputN) {
      this.activeInput = inputN
    },
    onChange(input) {
      this.inputs[this.activeInput] = input
    },
    onKeyPress(button) {
      this.$refs.searchForm.$refs[this.activeInput].$emit('change', button)
    },
    onInputChange(input) {
      if (input) {
        this.inputs[this.activeInput] = input.target.value
      }
    },
    accept() {
      this.hide()
    },
    setPrefixNUmber(prefix) {
      this.$refs.searchForm.clearMSISDN()
      if (prefix === '98') {
        this.$refs.searchForm.firstDigit = '9'
        this.$refs.searchForm.secondDigit = '8'
        this.$refs.searchForm.$refs.thirdDigit.select()
        this.$refs.searchForm.$refs.thirdDigit.focus()
      } else if (prefix === '94') {
        this.$refs.searchForm.firstDigit = '9'
        this.$refs.searchForm.secondDigit = '4'
        this.$refs.searchForm.$refs.thirdDigit.select()
        this.$refs.searchForm.$refs.thirdDigit.focus()
      } else if (prefix === '918') {
        this.$refs.searchForm.firstDigit = '9'
        this.$refs.searchForm.secondDigit = '1'
        this.$refs.searchForm.thirdDigit = '8'
        this.$refs.searchForm.$refs.fourthDigit.select()
        this.$refs.searchForm.$refs.fourthDigit.focus()
      } else if (prefix === '71') {
        this.$refs.searchForm.firstDigit = '7'
        this.$refs.searchForm.secondDigit = '1'
        this.$refs.searchForm.$refs.thirdDigit.select()
        this.$refs.searchForm.$refs.thirdDigit.focus()
      } else if (prefix === '17') {
        this.$refs.searchForm.firstDigit = '1'
        this.$refs.searchForm.secondDigit = '7'
        this.$refs.searchForm.$refs.thirdDigit.select()
        this.$refs.searchForm.$refs.thirdDigit.focus()
      } else if (prefix === '75') {
        this.$refs.searchForm.firstDigit = '7'
        this.$refs.searchForm.secondDigit = '5'
        this.$refs.searchForm.$refs.thirdDigit.select()
        this.$refs.searchForm.$refs.thirdDigit.focus()
      }
      this.$refs.searchForm.setFocusNext('thirdDigit', '')
    },
    show(e) {
      if (this.sensorActive) {
        if (e) {
          this.input = e.target
          this.layout = e.target.dataset.layout
        }

        if (!this.visible) {
          this.visible = true
        }
      } else {
        this.visible = false
      }
    },
    hide() {
      this.visible = false
    },
    next() {
      const inputs = document.querySelectorAll('input')
      let found = false
      inputs.forEach((item, i) => {
        if (!found && item === this.input && i < inputs.length - 1) {
          found = true
          this.$nextTick(() => {
            inputs[i + 1].focus()
          })
        }
      })
      if (!found) {
        this.input.blur()
        this.hide()
      }
    },
  },
  created() {
    if (this.$route.query.sensor && this.$route.query.sensor === 'active') {
      this.sensorActive = true
    } else {
      this.sensorActive = false
    }
  },
}

</script>

<style lang='scss'>
@import '@core/scss/vue/libs/vue-select.scss';
</style>
